// extracted by mini-css-extract-plugin
export default {"container":"Container_container__JqBze","min-height":"Container_min-height__I3CIH","start":"Container_start__Ysn-k","column":"Container_column__aehPU"};